export default [
  {
    path: "profile",
    name: "profile",
    redirect: { name: "profile-show" },
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "profile-show",
        meta: { requiresAuth: true },
        component: () => import("@/modules/profile/views/ProfileView.vue"),
        children: [
          {
            path:"seller",
            name:"profile-show-nav-seller-codes",
            meta: { requiresAuth: true, roles: ['superadmin', 'vendedor'] },
            component: () => import("@/modules/profile/views/tabs/ProfileSellerCodes.vue")

          }
        ],  
      }
    ],
  },
];
